module.exports = __webpack_public_path__ + "static/Os-46f2923372c92bff6eb3a4291e6bbebd.svg";